export default __webpack_public_path__ + "images/models/4495d356d169e6e1d2b0ec95ee3a544d.usdz";